import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { protectedRoutes } from '@/config/routes';

import { MENU_ITEMS } from '@/constants/menuItems';

import { IUser } from '@/types/user';

import { filterRoutesByPermissions } from '@/utils/route-filter';

interface MenuNavProps {
  handleMenuItemClick?: (action?: () => void) => void;
  onSignOut: () => void;
  variant?: 'desktop' | 'mobile';
  user: IUser;
}

export function MenuNav({
  onSignOut,
  handleMenuItemClick,
  variant = 'desktop',
  user,
}: MenuNavProps) {
  const navigate = useNavigate();
  const paddingClass = variant === 'mobile' ? 'py-3' : 'py-2';

  const visibleMenuItems = useMemo(() => {
    const allowedRoutes = filterRoutesByPermissions(protectedRoutes, user.scope);
    const allowedPaths = new Set<string>(allowedRoutes.map((route) => route.path));
    return MENU_ITEMS.filter((item) => allowedPaths.has(item.path));
  }, [user.scope]);

  const handleMenuClick = (e: React.MouseEvent, path: string) => {
    e.stopPropagation();
    e.preventDefault();
    handleMenuItemClick?.(() => navigate(path));
  };

  return (
    <nav className="py-1">
      {visibleMenuItems.map((item) => (
        <button
          key={item.path}
          onClick={(e) => handleMenuClick(e, item.path)}
          className={`w-full px-4 text-left ${paddingClass} text-sm text-gray-700 transition-colors hover:bg-gray-50`}
        >
          {item.label}
        </button>
      ))}
      <div className="my-1 border-t border-gray-100"></div>
      <button
        onClick={onSignOut}
        className={`w-full px-4 text-left ${paddingClass} text-sm text-red-600 transition-colors hover:bg-red-50`}
      >
        Sign-out
      </button>
    </nav>
  );
}
